export default function (location) {
  if (window.gtag) {
    window.gtag('config', 'UA-85615776-4', { 'page_path': location.pathname + location.search })
  }
}
